(() => {
  const MAX=100, MIN=2, MAX_BYTES=20*1024*1024;
  const TYPES=new Set(['image/jpeg','image/png','image/webp','image/heic','image/heif']);
  const EXT=/\.(jpe?g|png|webp|heic|heif)$/i;
  function init(root){
    if(root.dataset.initialized)return; root.dataset.initialized='true';
    const form=document.getElementById(root.dataset.formId); if(!form)return;
    const customer=root.querySelector('.flora-photo-uploader__customer-input');
    const customerProp=root.querySelector('[data-customer-name-property]');
    const input=root.querySelector('.flora-photo-uploader__input'),pick=root.querySelector('.flora-photo-uploader__pick');
    const grid=root.querySelector('.flora-photo-uploader__grid'),summary=root.querySelector('.flora-photo-uploader__summary');
    const error=root.querySelector('.flora-photo-uploader__error'),progress=root.querySelector('.flora-photo-uploader__progress');
    const bar=progress.querySelector('span'),progressText=root.querySelector('.flora-photo-uploader__progress-text');
    const uploadId=root.querySelector('[data-upload-id]'),uploadCount=root.querySelector('[data-upload-count]');
    const external=root.querySelector('.flora-photo-uploader__external-checkbox'),photoSource=root.querySelector('[data-photo-source]');
    let quantity=form.querySelector('[name="quantity"]')||root.closest('.product, product-info, .product__info-container')?.querySelector('input[name="quantity"]')||document.querySelector('input[name="quantity"]');
    let files=[],uploading=false,readyToSubmit=false,lastValidQty=MIN;
    function enforceQty(){
      if(!quantity) quantity=form.querySelector('[name="quantity"]')||root.closest('.product, product-info, .product__info-container')?.querySelector('input[name="quantity"]')||document.querySelector('input[name="quantity"]');
      if(!quantity)return MIN;
      let v=parseInt(quantity.value,10);
      if(!Number.isFinite(v)||v<MIN)v=MIN;
      if(v>MAX)v=MAX;
      quantity.min=String(MIN); quantity.setAttribute('min',String(MIN));
       quantity.max=String(MAX); quantity.setAttribute('max',String(MAX));
      quantity.value=String(v); lastValidQty=v; return v;
    }
    const qty=()=>enforceQty();
    const showError=(m='')=>{error.textContent=m;error.hidden=!m};
    const revoke=x=>{if(x.url)URL.revokeObjectURL(x.url)};
    function resetSession(){uploadId.value='';uploadCount.value='';customerProp.value='';photoSource.value='';readyToSubmit=false}
    function render(){
      grid.innerHTML='';
      files.forEach((item,i)=>{
        const card=document.createElement('div');card.className='flora-photo-uploader__card';
        const img=document.createElement('img');img.className='flora-photo-uploader__thumb';img.src=item.url;img.alt=`Selected photo ${i+1}`;
        const name=document.createElement('div');name.className='flora-photo-uploader__name';name.textContent=item.file.name;name.title=item.file.name;
        const actions=document.createElement('div');actions.className='flora-photo-uploader__card-actions';
        const replace=document.createElement('button');replace.type='button';replace.textContent='Replace';
        const remove=document.createElement('button');remove.type='button';remove.textContent='Remove';
        replace.onclick=()=>chooseReplacement(i); remove.onclick=()=>{revoke(files[i]);files.splice(i,1);render()};
        actions.append(replace,remove);card.append(img,name,actions);grid.append(card);
      });
      const q=qty(),n=files.length;
      if(external.checked){summary.textContent='Photo upload is not required.';pick.disabled=true;input.disabled=true;grid.classList.add('is-disabled');}
      else{summary.textContent=n===q?`${n} of ${q} photos selected. Ready to add to cart.`:`${n} of ${q} photos selected. Please select ${q-n>0?q-n+' more':n-q+' fewer'}.`;pick.disabled=false;input.disabled=false;grid.classList.remove('is-disabled');}
      resetSession();showError();
    }
    function validate(f){if(!(TYPES.has(f.type)||EXT.test(f.name)))return'Only JPG, JPEG, PNG, WEBP, HEIC and HEIF images are allowed.';if(f.size>MAX_BYTES)return`${f.name} is larger than 20 MB.`;return''}
    function addFiles(list){showError();for(const f of list){const m=validate(f);if(m){showError(m);continue}if(files.length>=MAX){showError('Maximum 100 photos allowed.');break}files.push({file:f,url:URL.createObjectURL(f)})}input.value='';render()}
    function chooseReplacement(i){const r=document.createElement('input');r.type='file';r.accept=input.accept;r.onchange=()=>{const f=r.files?.[0];if(!f)return;const m=validate(f);if(m)return showError(m);revoke(files[i]);files[i]={file:f,url:URL.createObjectURL(f)};render()};r.click()}
    pick.onclick=()=>input.click();input.onchange=()=>addFiles([...input.files]);
    if(quantity){
      enforceQty();
      quantity.addEventListener('change',()=>{enforceQty();render()});
      quantity.addEventListener('input',()=>{if(parseInt(quantity.value||'0',10)<MIN) quantity.value=String(MIN);render()});
    }
    // Dawn can rewrite quantity state when a variant changes. Restore/enforce the minimum after it settles.
    document.addEventListener('change',e=>{
      if(e.target.matches('input[type="radio"],select')){
        const keep=Math.max(MIN,lastValidQty||MIN);
        setTimeout(()=>{if(quantity){quantity.min=String(MIN);if((parseInt(quantity.value,10)||0)<MIN)quantity.value=String(keep);render()}},50);
      }
    });
    customer.addEventListener('input',()=>{resetSession();showError()});
    external.addEventListener('change',render);
    form.addEventListener('submit',async e=>{
      if(readyToSubmit){readyToSubmit=false;return}
      if(uploading){e.preventDefault();e.stopImmediatePropagation();return}
      const name=customer.value.trim(),q=qty();

      // Validate before deciding whether the native Dawn submit can continue.
      if(quantity && (parseInt(quantity.value,10)||0)<MIN){
        e.preventDefault();e.stopImmediatePropagation();
        quantity.value=String(MIN);showError('Minimum order quantity is 2.');return;
      }
      if(name.length<2){
        e.preventDefault();e.stopImmediatePropagation();
        showError('Please enter the customer name before uploading.');customer.focus();return;
      }
      if(q<MIN||q>MAX){
        e.preventDefault();e.stopImmediatePropagation();
        showError('Quantity must be between 2 and 100.');return;
      }

      // WhatsApp/Gmail path is synchronous: populate Shopify properties and let
      // THIS SAME first submit event continue to Dawn. No second click/requestSubmit.
      if(external.checked){
        customerProp.value=name;
        photoSource.value='WhatsApp or Gmail';
        uploadId.value='';
        uploadCount.value='';
        showError();
        return;
      }

      // Website-upload path must pause Dawn while files upload asynchronously.
      e.preventDefault();e.stopImmediatePropagation();
      if(files.length!==q){showError(`Please select exactly ${q} photos. You currently have ${files.length}.`);return}
      uploading=true;root.classList.add('is-uploading');progress.hidden=false;bar.style.width='0%';showError();
      try{
        progressText.textContent='Preparing your upload…';
        const sresp=await fetch(`${root.dataset.baseEndpoint}/session`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({customerName:name})});
        const sdata=await sresp.json().catch(()=>({}));
        if(!sresp.ok||!sdata.success||!sdata.uploadId)throw new Error(sdata.error||'Could not create upload ID.');
        const session=sdata.uploadId;
        for(let i=0;i<files.length;i++){
          progressText.textContent=`Uploading photo ${i+1} of ${files.length}…`;
          const fd=new FormData();fd.append('file',files[i].file);fd.append('sessionId',session);fd.append('fileName',`${String(i+1).padStart(2,'0')}-${files[i].file.name}`);
          const resp=await fetch(`${root.dataset.baseEndpoint}/upload`,{method:'POST',body:fd});const data=await resp.json().catch(()=>({}));
          if(!resp.ok||!data.success)throw new Error(data.error||`Photo ${i+1} upload failed.`);
          bar.style.width=`${Math.round((i+1)/files.length*100)}%`;
        }
        customerProp.value=name;uploadId.value=session;uploadCount.value=String(files.length);photoSource.value='Website Upload';
        progressText.textContent=`${files.length} photos uploaded successfully. Upload ID: ${session}`;
        readyToSubmit=true;uploading=false;root.classList.remove('is-uploading');form.requestSubmit();
      }catch(err){uploading=false;root.classList.remove('is-uploading');progressText.textContent='Upload stopped.';showError(err.message||'Upload failed. Please try again.')}
    },true);
    render();
  }
  function boot(){document.querySelectorAll('[data-flora-photo-uploader]').forEach(init)}
  document.addEventListener('DOMContentLoaded',boot);document.addEventListener('shopify:section:load',boot);
})();